import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ExpandableComponent } from '../../../../ui/display/expandable/expandable.component';
/**
 * Block data mered with model data
 */
export namespace NCmsProductDelivery {
    export const BLOCK_ID = 'cms-product-delivery';
    export interface IBlockData extends Catalog.IBlockData<IBlockDataContent> {}
    export interface IBlockDataContent {
        content: string;
    }
}
@Component({
    selector: 'cms-product-delivery',
    templateUrl: './cms-product-delivery.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ExpandableComponent, CommonModule, ICmsClientModule]
})
@ICmsComponent<CmsProductDeliveryComponent>({
    id: NCmsProductDelivery.BLOCK_ID,
    block: {
        url: NCmsProductDelivery.BLOCK_ID
    },
    onDemandOnly: true,
    name: 'Product size guide modal',
    description: 'Product size guide modal component',
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            title: 'Copy',
            key: 'copy',
            required: true,
            default:
                '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Proin nibh augue, suscipit a, scelerisque sed, lacinia in.<p>'
        }
    ]
})
export class CmsProductDeliveryComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NCmsProductDelivery.IBlockData;
}
